import FlightInfoCardContentMobile from "./FlightInfoCardContent.mobile";

export default FlightInfoCardContentMobile;
